// @flow
import { colors } from 'bench-style-constants';

const currencyFormatter = new Intl.NumberFormat('en-US', {
  currency: 'USD',
  maximumFractionDigits: 2,
  minimumFractionDigits: 2,
  style: 'currency',
});

/**
 * Given an amount in cents, returns a currency formatted string in dollars.
 */
export const formatCentsToDollars = (amount: number): string =>
  currencyFormatter.format(amount / 100);

/**
 * Given an amount in cents, returns a currency formatted string in dollars using accounting
 * notation for negative values.
 * E.g. ($2,432.34)
 */
export const formatAccountingAmount = (amount: number): string =>
  amount < 0 ? `(${formatCentsToDollars(-1 * amount)})` : formatCentsToDollars(amount);

/**
 * Takes in cents and always returns positive dollar amount, even if the number is negative
 * Eg. -243234 returns $2,432.34
 * Eg. 243234 returns $2,432.34
 */
export const formatCentsToPositiveDollars = (amount: number): string =>
  formatCentsToDollars(Math.abs(amount));

export const getCurrencyColor = (amount: number): string => {
  if (amount > 0) {
    return colors.bonsai;
  } else if (amount < 0) {
    return colors.copper;
  }
  return colors.dust;
};
